'use client';

import { Icons } from '@/components/Icons';
import { RolesE } from '../types/enums';
import { useTranslation } from 'react-i18next';
import { paths } from '@/lib/types/types';
import { LucideIcon } from 'lucide-react';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
const createRoutes = (t: any) => ({
  routes_track_trace_dashboard: [
    {
      title: t('dashboard'),
      url: '/',
      icon: Icons.LayoutDashboard,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },
    {
      title: t('shipment_insights.title'),
      icon: Icons.PackageSearch,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true,
      items: [
        {
          title: t('shipment_insights.control_tower'),
          url: '/control_tower',
          icon: Icons.Radar,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,
            RolesE.TENANT_USER,
            RolesE.CUSTOMER_ADMIN,
            RolesE.CUSTOMER_USER
          ],
          isActive: true,
          isVisible: true
        },
        {
          title: t('shipment_insights.all_shipments'),
          url: '/all_shipments',
          icon: Icons.Package,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,
            RolesE.TENANT_USER,
            RolesE.CUSTOMER_ADMIN,
            RolesE.CUSTOMER_USER
          ],
          isActive: true,
          isVisible: true
        }
      ]
    },
    {
      title: t('analytics.title'),
      icon: Icons.BarChart3,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true,
      items: [
        /*{
          title: t('analytics.air'),
          url: '/analytics/air',
          icon: Icons.Plane,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,
            RolesE.TENANT_USER,
            RolesE.CUSTOMER_ADMIN,
            RolesE.CUSTOMER_USER
          ],
          isActive: true
        },
        {
          title: t('analytics.ocean'),
          url: '/analytics/ocean',
          icon: Icons.Ship,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,
            RolesE.TENANT_USER,
            RolesE.CUSTOMER_ADMIN,
            RolesE.CUSTOMER_USER
          ],
          isActive: true
        },*/
        {
          title: t('analytics.road'),
          url: '/analytics/road',
          icon: Icons.Truck,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,
            RolesE.TENANT_USER,
            RolesE.CUSTOMER_ADMIN,
            RolesE.CUSTOMER_USER
          ],
          isActive: true
        }/*,
        {
          title: t('analytics.rail'),
          url: '/analytics/rail',
          icon: Icons.Train,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,
            RolesE.TENANT_USER,
            RolesE.CUSTOMER_ADMIN,
            RolesE.CUSTOMER_USER
          ],
          isActive: true
        }*/
      ]
    },
    {
      title: t('settings.title'),
      icon: Icons.Settings,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN
      ],
      isActive: true,
      isVisible: true,
      items: [
        {
          title: t('settings.carriers'),
          url: '/carriers',
          icon: Icons.Factory,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,
            RolesE.TENANT_USER,
            RolesE.CUSTOMER_ADMIN
          ],
          isActive: true
        },    
        {
          title: t('settings.parties'),
          url: '/parties',
          icon: Icons.Users,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,
            RolesE.TENANT_USER,
            RolesE.CUSTOMER_ADMIN
          ],
          isActive: true
        }
      ]
    }
  ],
  routes_audit_dashboard: [
    {
      title: t('audit.dashboard'),
      url: '/audit',
      icon: Icons.GaugeCircle,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },
    {
      title: t('audit.invoices'),
      url: '/audit/invoices',
      icon: Icons.FileText,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },
    {
      title: t('audit.rules'),
      url: '/audit/rules',
      icon: Icons.PencilRuler,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    }
  ],  
  routes_quotes_dashboard: [
    {
      title: t('quotes.dashboard'),
      url: '/quotes',
      icon: Icons.GaugeCircle,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },
    {
      title: t('quotes.quotes'),
      url: '/quotes/list',
      icon: Icons.FileText,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },
    {
      title: t('quotes.contracts'),
      url: '/quotes/contracted_rates',
      icon: Icons.ScrollText,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },
    {
      title: t('quotes.recent_activities'),
      url: '/recent_activity',
      icon: Icons.History,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: false
    }
  ],
  routes_market_dashboard: [
    {
      title: t('market.dashboard'),
      url: '/market_intelligence',
      icon: Icons.LayoutPanelLeft,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: false,
      isVisible: false
    },
    {
      title: t('market.hts_codes'),
      url: '/market_intelligence/hts_codes',
      icon: Icons.PencilRuler,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },    
    {
      title: t('market.tariffs'),
      url: '/market_intelligence/tariffs',
      icon: Icons.FileSpreadsheet,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },
    {
      title: t('market.landed_cost_calc'),
      url: '/market_intelligence/landed_cost_calc',
      icon: Icons.Calculator,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: true,
      isVisible: true
    },    
    {
      title: t('market.recent_activities'),
      url: '/recent_activity',
      icon: Icons.Timer,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN,
        RolesE.CUSTOMER_USER
      ],
      isActive: false,
      isVisible: false
    }
  ],
  routes_admin_management: [
    {
      title: t('admin.admin_tools'),
      icon: Icons.SettingsIcon,
      roles: [
        RolesE.SUPER_ADMIN,
        RolesE.ZEUS_ADMIN,
        RolesE.TENANT_ADMIN,
        RolesE.TENANT_USER,
        RolesE.CUSTOMER_ADMIN
      ],
      isActive: true,
      isVisible: true,
      items: [
        {
          title: t('admin.tenant_management'),
          url: '/admin/tenants',
          icon: Icons.Building2,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN           
          ],
          isActive: true
        },
        {
          title: t('admin.customer_management'),
          url: '/admin/customers',
          icon: Icons.UserSquare2,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN            
          ],
          isActive: true
        },
        {
          title: t('admin.user_management'),
          url: '/admin/users',
          icon: Icons.UserCircle,
          roles: [
            RolesE.SUPER_ADMIN,
            RolesE.ZEUS_ADMIN,
            RolesE.TENANT_ADMIN,            
            RolesE.CUSTOMER_ADMIN
          ],
          isActive: true
        }        
      ]
    }
  ],
  routes_marketing: [
    { title: 'Products', link: '/products', desc: 'Supply chain solutions tailored to your business needs',
      routes: [
      { title: 'Supply Chain Intelligence', link: '/products/supplychainintel', image: '/static/images/marketing/supply_chain_intel.jpg', desc: 'Track real-time shipment locations, analyze supply chain performance, and gain actionable insights through predictive analytics' },
      { title: 'Rates Intelligence', link: '/products/ratesintel', image: '/static/images/marketing/rates_intel.jpg', desc: 'Streamline quoting with our Smart Quotation platform for automated, accurate rate management and pricing optimization'},
      { title: 'Market Intelligence', link: '/products/marketintel', image: '/static/images/marketing/market_intel.jpg', desc: 'Simplify global trade with comprehensive compliance tools including HTS lookup, tariff database, and landed cost calculator' }
    ] },
    { title: 'How It Works', link: '/howitworks' },
    { title: 'Use Cases', link: '/usecases' },    
    /*{ title: 'Pricing', link: '/pricing' },*/
    { title: 'FAQs', link: '/faq' },
    { title: 'Contact Us', link: '/contact' },
    { title: 'Track Shipment', link: `/track_shipment/${process.env.NEXT_PUBLIC_DEMO_VULCAN_ID}/search` }
  ],
  footer_nav: {
    about: {
      title: 'About',
      routes: [
        /*{ title: 'Pricing', link: '/pricing' },*/
        { title: 'FAQs', link: '/faq' }
      ]
    },
    products: {
      title: 'Products',
      routes: [
        { title: 'Supply Chain Intelligence', link: '/products/supplychainintel' },
        { title: 'Rates Intelligence', link: '/products/ratesintel' },
        { title: 'Market Intelligence', link: '/products/marketintel' }
      ]
    },
    resources: {
      title: 'Resources',
      routes: [
        { title: 'Blog', link: '/blog' },
        // { title: 'Help Center', link: '/docs/getting-started' }
      ]
    },
    legal: {
      title: 'Legal',
      routes: [
        { title: 'Privacy Policy', link: '/privacypolicy' },
        { title: 'Terms and Conditions', link: '/termsandconditions' }
      ]
    }
  },
  // These don't need translation as they're internal paths
  routes_track_trace_dashboard_subroutes: {
    projects: {
      editor: { title: 'Create', link: '/projects/editor' },
      viewer: { title: 'View', link: '/projects/viewer' }
    }
  }
  // redirects: {
  //   dashboard: {
  //     dashboardBase: '/dashboard/',
  //     toDashboard: '/',
  //     settings: {
  //       toPaymentResult: '/billing_subscription/payment_result',
  //     },
  //     todos: { toMyTodos: '/todos/my-todos', createTodos: '/todos/create' }
  //   },
  //   auth: {
  //     toLogin: '/auth/login',
  //     requireAuth: '/auth/login',
  //     authConfirm: '/auth/confirmed',
  //     callback: '/api/auth-callback'
  //   },
  //   user: {
  //     toUserDashboard: '/user/dashboard',
  //     toOrgInvite: '/user/org-invite'
  //   }
  // }
});

export { paths };

// Hook for client components
export const useRoutes = () => {
  const { t } = useTranslation('routes'); // 'routes' namespace
  return createRoutes(t);
};

// Type for the translation function
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type TranslationFunction = (key: string, options?: { [key: string]: any }) => string;

// For server components or static usage
export const getStaticRoutes = (t: TranslationFunction) => createRoutes(t);

// Helper function to get a specific dashboard routes based on type
export const getDashboardRoutes = (
  t: TranslationFunction,
  type: 'track_trace' | 'quotes' | 'market' | 'admin'
) => {
  const allRoutes = createRoutes(t);
  switch (type) {
    case 'track_trace':
      return allRoutes.routes_track_trace_dashboard;
    case 'quotes':
      return allRoutes.routes_quotes_dashboard;
    case 'market':
      return allRoutes.routes_market_dashboard;
    case 'admin':
      return allRoutes.routes_admin_management;
    default:
      return [];
  }
};

// Helper to get marketing routes
export const getMarketingRoutes = (t: TranslationFunction) => {
  return createRoutes(t).routes_marketing;
};

// Helper to get footer navigation
export const getFooterNav = (t: TranslationFunction) => {
  return createRoutes(t).footer_nav;
};

// Export the redirects separately as they don't need translation
export const redirects = {
  dashboard: {
    dashboardBase: '/dashboard/',
    toDashboard: '/',
    settings: {
      toPaymentResult: '/billing_subscription/payment_result'
    },
    todos: { toMyTodos: '/todos/my-todos', createTodos: '/todos/create' }
  },
  auth: {
    toLogin: '/auth/login',
    requireAuth: '/auth/login',
    authConfirm: '/auth/confirmed',
    callback: '/api/auth-callback'
  },
  user: {
    toUserDashboard: '/user/dashboard',
    toOrgInvite: '/user/org-invite'
  }
};

// Types for route items
export interface RouteItem {
  title: string;
  url?: string;
  link?: string;
  icon?: LucideIcon;
  roles?: RolesE[];
  isActive?: boolean;
  isVisible?: boolean;
  items?: RouteItem[];
}

// Export default for backward compatibility
export default createRoutes;
